// extracted by mini-css-extract-plugin
module.exports = {"container":"MyDashboard_container__2iAWO","content":"MyDashboard_content__2NGlv","header":"MyDashboard_header__29Tms","title":"MyDashboard_title__2TNy7"};